import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { typedPageSelectors, usePage } from 'client/store'
import {
  ForgotPasswordUi,
  ForgotPasswordWrapperUi,
} from 'common/components/entities/CustomLogin'
import { CustomLoginForgotPasswordInterface } from 'common/types/entities/CustomLoginForgotPasswordInterface'
import React from 'react'
import { useCustomLoginDescendantIds } from './CustomLogin'

interface ForgotPasswordProps {
  entity: CustomLoginForgotPasswordInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

export const ForgotPassword = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: ForgotPasswordProps) => {
  const entityIds = useCustomLoginDescendantIds()

  const locale = usePage(typedPageSelectors.getPageLocale)

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      dropBoxAllowedEntityIds={entityIds}
      isCopyAllowed={false}
      isRemoveAllowed={false}
      isSaveAllowed={false}
    >
      <ForgotPasswordWrapperUi
        align={entity.textAlign || 'center'}
        mobileAlign={entity.mobileTextAlign || 'center'}
      >
        <ForgotPasswordUi {...entity} href={`/${locale}/restore-password`}>
          {entity.text}
        </ForgotPasswordUi>
      </ForgotPasswordWrapperUi>
    </BaseEntityNew>
  )
}
